import { Navigate } from 'react-router-dom'
import travelAgentService from '../services/travelAgentService'
import OffMarketAccessBlockedPage from '../pages/OffMarketAccessBlockedPage'

/** Requires login; without off-market access, show a block page (still on /off-market-stays). */
const OffMarketProtectedRoute = ({ children }) => {
  if (!travelAgentService.isAuthenticated()) {
    return <Navigate to="/login" replace />
  }
  if (!travelAgentService.hasOffMarketAccess()) {
    return <OffMarketAccessBlockedPage />
  }
  return children
}

export default OffMarketProtectedRoute
